<template>
  <div class="icon-container" @click="toggleIframe">
    <iframe
      class="chat-bot-container"
      v-show="visible"
      :src="`https://dashboard.tinytalk.ai/bots/${chatBotId}/chat`"
      width="100%"
      height="500"
    />
    <fa-icon-compat v-if="!visible" icon="fa-solid fa-message" />
    <fa-icon-compat v-else icon="fa-solid fa-xmark" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  data() {
    return {
      visible: false,
      chatBotId: process.env.VUE_APP_CHATBOT_ID
    };
  },
  methods: {
    toggleIframe() {
      this.visible = !this.visible;
    }
  }
});
</script>

<style scoped lang="scss">
.icon-container {
  position: fixed;
  bottom: 55px;
  right: 30px;
  z-index: 100;
  display: flex;
  justify-content: flex-end;

  i {
    background-color: var(--color-blue);
    border-radius: 50%;
    padding: 17px;
    color: var(--color-white);
    cursor: pointer;
    font-size: 24px;

    &::before {
      width: 24px;
      display: block;
    }
  }
}

.chat-bot-container {
  position: fixed;
  bottom: 90px;
  width: 500px;
  max-width: 100%;
  border: 0;
  box-shadow: -4px 0px 14px rgba(0, 0, 0, 0.1);
  background-color: var(--color-white);
  border-radius: var(--radius-2);
}

@media only screen and (max-width: 550px) {
  .chat-bot-container {
    right: 8px;
    z-index: 4;
    width: 95%;
    max-width: 95%;
  }
}
</style>
